document.addEventListener("DOMContentLoaded", function () {
  const facetsItemTags = document.querySelectorAll(".facets__item-tag");

  facetsItemTags.forEach(function (tag) {
    const checkbox = tag.querySelector("input");
    const link = tag.querySelector("a");

    checkbox.addEventListener("change", function () {
      link.click();
    });
  });
});
